import Analytics from './Analytics.js';
import UserEvent from './UserEvent.js';
import Pageview from './Pageview.js';

export default Analytics;

export {
  UserEvent,
  Pageview,
};
